import { render, staticRenderFns } from "./AnimeWatchHistoryRecommender.vue?vue&type=template&id=27f21d17&"
import script from "./AnimeWatchHistoryRecommender.vue?vue&type=script&lang=js&"
export * from "./AnimeWatchHistoryRecommender.vue?vue&type=script&lang=js&"
import style0 from "./AnimeWatchHistoryRecommender.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/root/animewreck/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCheckbox } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSlider } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardText,VCheckbox,VContainer,VFlex,VLayout,VSlider})
